// @ts-nocheck
/* eslint-enable */
import styled, { css } from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { inline } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';
import { transform } from 'app/shared/styles/_mixins';
import { viewports } from 'app/shared/styles/_breakpoints';
import { smoothTransition } from 'app/shared/styles/_mixins';

export const Button = styled.button`
  ${font.sm};
  align-items: center;
  background-color: ${colors['$hpx-white']};
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  height: 32px;
  min-width: fit-content;
  padding: 6px 12px;
  color: ${colors['$hpx-blue-600']};
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 1px auto ${colors['$hpx-teal-600']};
    outline-offset: 1px;
  }

  ${(props) =>
    props.large === true &&
    css`
      height: 48px;
      width: 100%;

      @media ${viewports['lg-and-up']} {
        width: 150px;
      }
    `};

  ${(props) =>
    props.stretch === true &&
    css`
      height: 48px;
      width: 100%;
    `}

  ${(props) =>
    props.buttonType === 'text' &&
    `
        background-color: none;
        border: none;
        font-weight: bold;
        color: ${colors['$hpx-grey-600']};
    `};

  ${(props) =>
    props.buttonType === 'link' &&
    `
        background-color: none;
        border: none;
        text-decoration: underline;
        color: ${colors['$hpx-grey-600']};
    `};

  ${(props) =>
    props.buttonType === 'primary' &&
    `
        background-color: ${colors['$hpx-teal-500']};
        color: ${colors['$hpx-white']};
        padding: 0px 16px;
        font-weight: bold;
    `};

  ${(props) =>
    props.buttonType === 'primary-outline' &&
    css`
        background-color: ${colors['$hpx-white']};
        color: ${colors['$hpx-teal-500']};
        border: 1px solid ${colors['$hpx-teal-500']}
        padding: 0px 16px;
        font-weight: bold;
        &:hover {
            ${smoothTransition}
            background: ${colors['$hpx-grey-100']};
        }
    `};

  ${(props) =>
    props.disabled === true &&
    `
        font-weight: normal;
        border: 1px solid ${colors['$hpx-grey-500']};
        background-color: ${colors['$hpx-grey-100']};
        color: ${colors['$hpx-grey-600']};
        pointer-events: none;
        cursor: not-allowed;
    `};

  ${(props) =>
    props['aria-disabled'] &&
    `
        font-weight: normal;
        border: 1px solid ${colors['$hpx-grey-500']};
        background-color: ${colors['$hpx-grey-400']};
        color: ${colors['$hpx-grey-600']};
        pointer-events: none;
        cursor: not-allowed;
    `}

  ${(props) =>
    props.active &&
    `
        border: 1px solid ${colors['$hpx-teal-600']};
        color: ${colors['$hpx-teal-600']};
        font-weight: bold;
    `}
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.alignItems &&
    css`
      align-items: ${props.alignItems};
    `}
`;

export const Icon = styled.img`
  ${inline._1x};
`;

export const CaratSpan = styled.span`
  padding-left: 4px;
`;

export const Carat = styled.img`
  ${transform('rotate(-90deg)')}

  ${(props) =>
    props.isActive &&
    `
        ${transform('rotate(90deg)')}
    `}
`;
